import React, { useEffect, useState } from 'react';
import { withRouter } from "react-router-dom";
import Api from '../Services/Api';
import Alert from '../Services/Alert';
import IncMsg from './IncMsg';
import { FormLabel } from 'react-bootstrap';

export const AllowedRegions = (props) => {
    let [data, setData] = useState('');
    let [success, setSuccess] = useState('');
    let [fail, setFail] = useState('');

    function getRegionData() {
        var data = {};
        Api.get('region', data).then(resp => {
            var respData = resp.data;
            if (respData.status == 1) {
                setData(respData.data);
            } else {
                setFail(respData.message);
            }
        });
    }

    function onUpdateStatus(id, statusTo, name) {
      const sendData = { id: id, status: statusTo };
      const message = `Are you sure You want ${statusTo == "1" ? `active` : `in active`} ${name}, region for app use?`;
      Alert.warning(message).then((result) => {
        if (result.isConfirmed) {
          Api.post("region/status", sendData).then((res) => res.data).then(res => {
              if (res.status) {
                Alert.success(res.message);
                getRegionData();
              } else {
                Alert.error(res.message)
              }
          }).catch(error => {
              Alert.error(error.message)
          })
        }
      });
    }

    useEffect(() => {
        getRegionData();
    }, [])

    return (
        <>
            <section className="main-content marketadd_main_sec">
                <div className="page-content">
                    <div className="container-fluid">
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="card">
                                    <div className="card-body">
                                        <IncMsg success={success} fail={fail} />
                                        <div className="header-text">
                                            <h4 className="card-title mb-4">Allowed Regions List</h4>
                                        </div>
                                        <div className="table-responsive">
                                            <table className="table align-middle table-nowrap mb-0">
                                                <thead className="table-light">
                                                    <tr>
                                                        <th className="align-middle">Name</th>
                                                        <th className="align-middle">Update Status</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {data && data.length > 0 && data.map((sobj, key) => (
                                                        <tr key={key}>
                                                            <td>{sobj.name}</td>
                                                            
                                                            <td>
                                                                {(sobj.status ? (<>
                                                                    <FormLabel className="custom-label text-success" title='Click To In Active' style={{ cursor: "pointer" }} onClick={() => onUpdateStatus(sobj._id, '0', sobj.name)}>Active</FormLabel>
                                                                    </>
                                                                ) : (<>
                                                                    <FormLabel className="custom-label text-danger" title='Click To Active' onClick={() => onUpdateStatus(sobj._id, '1', sobj.name)}>In Active</FormLabel>
                                                                    </>
                                                                ))}
                                                            </td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                        </div>
                                        {/* end table-responsive  */}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default withRouter(AllowedRegions);